// Video gallery page
import { initVideoGallery, cleanupVideoGallery } from '../scripts/videos';
import { appendReturnToHouse } from '../scripts/navigation';

// Video metadata
const VIDEOS = [
  { id: 'BIOT3048', name: 'BIOT3048', recovered: '2024.03.17', duration: '??:??' },
  { id: 'IIDI6061', name: 'IIDI6061', recovered: '2024.03.17', duration: '??:??' },
  { id: 'KGFG9681', name: 'KGFG9681', recovered: '2024.03.17', duration: '??:??' },
  { id: 'NUQG3963', name: 'NUQG3963', recovered: '2024.03.17', duration: '??:??' },
  { id: 'PCNU7867', name: 'PCNU7867', recovered: '2024.03.17', duration: '??:??' },
  { id: 'ULED1917', name: 'ULED1917', recovered: '2024.03.17', duration: '??:??' },
];

/**
 * Render the video gallery page
 */
export function renderVideos(): void {
  const app = document.getElementById('app');
  if (!app) return;

  app.innerHTML = '';

  const container = document.createElement('div');
  container.className = 'videos-container';

  container.innerHTML = `
    <header class="videos-header" id="main-content" tabindex="-1">
      <div>> VIDEO ARCHIVE</div>
      <div class="videos-subheader">> RECOVERED FOOTAGE - AUTHENTICITY UNVERIFIED</div>
    </header>

    <div class="videos-list" role="list" aria-label="Video archive"></div>
  `;

  app.appendChild(container);

  // Initialize video gallery
  initVideoGallery(container, VIDEOS);

  // Add return to house navigation
  appendReturnToHouse(container, { className: 'videos-nav' });
}

/**
 * Cleanup videos page
 */
export function cleanupVideos(): void {
  cleanupVideoGallery();
}
